import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { DocumentType } from '../../../../../core';

@JsonConverter
export class DocumentTypeAdapter implements JsonCustomConvert<DocumentType | undefined> {
    serialize(type: DocumentType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): DocumentType | undefined {
        switch (type) {
            case 'DN':
                return DocumentType.DNI;
            case 'NIF':
                return DocumentType.NIF;
            case 'CI':
                return DocumentType.CIF;
            case 'NR':
                return DocumentType.NIE;
            case 'NN':
                return DocumentType.NIE_NOT_RESIDENT;
            case 'PN':
                return DocumentType.PASSPORT;
            case 'PL':
                return DocumentType.PASSPORT_LATIN;
            case 'PR':
                return DocumentType.PERMISSION;
            case 'TR':
                return DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT;
            case 'DI':
                return DocumentType.IDENTIFICATION_DOCUMENT;
            default:
                return undefined;
        }
    }
}
